import type { ReactNode } from 'react';
import { ElvaPageLoader, EmptyState } from '@elva/ui';
import { ErrorState } from './ErrorState';
import { getErrorMessage } from '@/data/errors';

export interface AsyncBoundaryProps {
  loading: boolean;
  error?: unknown;
  onRetry?: () => void;
  retrying?: boolean;
  isEmpty?: boolean;
  skeleton?: ReactNode;
  emptyState?: ReactNode;
  children: ReactNode;
}

export function AsyncBoundary({
  loading,
  error,
  onRetry,
  retrying = false,
  isEmpty = false,
  skeleton,
  emptyState,
  children,
}: AsyncBoundaryProps) {
  if (error) {
    return (
      <ErrorState
        message={getErrorMessage(error)}
        {...(onRetry ? { onRetry } : {})}
        retrying={retrying}
      />
    );
  }
  if (loading) {
    return <>{skeleton ?? <ElvaPageLoader />}</>;
  }
  if (isEmpty) {
    return <>{emptyState ?? <EmptyState title="Nothing here yet" sub="There's no data to show." />}</>;
  }
  return <>{children}</>;
}
